import HayFeverData from "./HayFever.json";
import WeightLossData from "./WeightLoss.json";

export interface TreatmentOption {
  consultationID: string;
  name: string;
  description: string;
  consultationURI: string;
}

export type TreatmentOptions = { [uid: string]: TreatmentOption };

export interface Category {
  uid: string;
  treatmentOptions: TreatmentOptions;
}
export function getCategory(category: string): Category {
  const categoryMap: { [key: string]: Category } = {
    "hay-fever": HayFeverData,
    "weight-loss": WeightLossData,
  };

  return categoryMap[category] ?? throwError(category);
}

function throwError(category: string) {
  throw new Error(`Couldn't find category information for category ${category}`);
}
